module.exports = __webpack_public_path__ + "static/a-titan-steps-into-a-galaxy-far-far-away-bb6883a07324145d3826d1efa6c76d5c.jpg";